import * as React from 'react';
import { OmitPolyfill } from '../common';
import { EllipsisCommonProps } from '../common/Ellipsis';

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    OmitPolyfill<EllipsisCommonProps, 'size'> {
  dataHook?: string;
  className?: string;
  light?: boolean;
  /** @deprecated use `size` instead */
  appearance?: HeadingAppearance;
  as?: keyof HTMLElementTagNameMap;
  size?: Size;
  id?: string;
}

export declare const Heading: React.FC<HeadingProps>;
export default Heading;
export type HeadingAppearance = 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6';
export type Size =
  | 'extraLarge'
  | 'large'
  | 'medium'
  | 'small'
  | 'tiny'
  | 'extraTiny';
